import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "../Context/Authentication/authContext";
import { CssBaseline, AppBar, Toolbar, styled, Dialog, DialogTitle } from "@mui/material";
import {
  AccountCircle,
  Public as SocialIcon,
  Fitbit as FitbitIcon,
  TravelExplore,
  PersonAdd as PersonAddIcon
} from "@mui/icons-material";
// import Logo from '../assets/slate-logo.svg';
import GroupsIcon from "@mui/icons-material/Groups";


import "./Welcome.scss";

import { Menu, MenuItem, IconButton } from "@mui/material";
import Logo from "../assets/slate-logo.svg";
import HomeIcon from "@mui/icons-material/Home";
import icon1 from "../assets/icon1.png";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import LogoutIcon from "@mui/icons-material/ExitToApp";
import MapPopUp from "../ArcGISMap/MapPopUp";


const WelcomeHeader = (props: any): ReactElement => {
  const navigate = useNavigate();
  const { dispatch, state }: any = React.useContext(authContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [censusMap, setCensusMap]: any = React.useState(false);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const showCensusPup = () => {
    setCensusMap(true)
  }

  const displayCensusMap = (val: boolean) => {
    setCensusMap(val)
  }

  const logout = () => {
    setAnchorEl(null);
    localStorage.clear();
    dispatch({
      type: "LOGOUT",
    });
  };

  const AddUser = () => {
    setAnchorEl(null);
    props.addUser()
    
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className="welcome-header">
        <Toolbar disableGutters={true}>
          <img
            id="Header-Logo"
            alt="header-logo"
            src={Logo}
            className="header-logo"
            onClick={() => navigate("/")}
          />
          <div className="header-right">
            <span className="username-text">
              Welcome {state?.user?.username}!
            </span>
            <IconButton
              size="large"
              color="inherit"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              sx={{ ml: 1 }}
              className="user-icon"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              className="welcome-header-menu"
            >
              <div className="new">
                <div className="header-main__menuContainer">
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/");
                      }}
                      className="welcome-header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <img
                          alt="icon-2"
                          src={icon2}
                          className="header-main__menuContainer__menuItem__iconContainer__icon"
                        />
                        <span>Home</span>
                      </div>
                    </MenuItem>
                  </div>
                  <div
                    className="header-main__menuContainer__menuItem"
                    style={{ marginTop: "-0.255rem" }}
                  >
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/home");
                      }}
                      style={{ marginTop: "-1rem !important" }}
                      className="mat-menu-item-sm welcome-header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <FitbitIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Analyze</span>
                      </div>
                    </MenuItem>
                  </div>
                </div>
                <div className="header-main__menuContainer">
                  <div
                    className="header-main__menuContainer__menuItem"
                    style={{ marginTop: "-0.255rem" }}
                  >
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/social");
                      }}
                      className="mat-menu-item-sm welcome-header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <SocialIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Social</span>
                      </div>
                    </MenuItem>
                  </div>
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/report");
                      }}
                      className="mat-menu-item-sm welcome-header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <img
                          alt="icon-3"
                          src={icon3}
                          className="header-main__menuContainer__menuItem__iconContainer__icon"
                        />
                        <span>Report</span>
                      </div>
                    </MenuItem>
                  </div>
                </div>
                {/* <div className="header-main__menuContainer">
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/geo");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <TravelExplore className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Mod</span>
                      </div>
                    </MenuItem>
                  </div>
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/geo/manteca-ca");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <TravelExplore className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Manteca</span>
                      </div>
                    </MenuItem>
                  </div>
                </div>
                <div className="header-main__menuContainer">
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/geo/roseville-ca");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <TravelExplore className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Roseville</span>
                      </div>
                    </MenuItem>
                  </div>
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/geo/elk-grove-ca");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <TravelExplore className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Elk Grove</span>
                      </div>
                    </MenuItem>
                  </div>
                </div> */}
                <div
                  className="header-main__menuContainer"
                  style={state.user.role==='admin'?{position:'relative',left:'12px',marginBottom: "0rem"}:{marginBottom: "0rem"}}

                >
             
                  <div
                    className="header-main__menuContainer__menuItem"
                  >
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        showCensusPup();
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <TravelExplore className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Visualize</span>
                      </div>
                    </MenuItem>
                  </div>
                  {
                    (state.user.role==='user' || state.user.role==='trial') && 
                    <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={logout}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Logout</span>
                      </div>
                    </MenuItem>
                  </div>


                  }
                  {state.user.role === "admin" && (
                    <div className="header-main__menuContainer__menuItem">
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/users");
                        }}
                        className="mat-menu-item-sm header-menu-item"
                      >
                        <div className="header-main__menuContainer__menuItem__iconContainer">
                          <GroupsIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                          <span>User Management</span>
                        </div>
                      </MenuItem>
                    </div>
                  )}
                </div>
               {
                state.user.role==='admin' && 
                <div
                className="header-main__menuContainer"
                style={{ marginBottom: "0rem" }}
              >
                     <div className="header-main__menuContainer__menuItem">
                  <MenuItem
                    onClick={logout}
                    className="mat-menu-item-sm header-menu-item"
                  >
                    <div className="header-main__menuContainer__menuItem__iconContainer">
                      <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                      <span>Logout</span>
                    </div>
                  </MenuItem>
                </div>
              </div>

               }
                
                
              </div>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      {censusMap && (
        <MapPopUp displayCensusMap={displayCensusMap}/>
      )}
      
    </div>
  );
};

export default WelcomeHeader;